module.exports = __webpack_public_path__ + "static/media/notifications.6981d5f7.svg";